module.exports = __webpack_public_path__ + "static/carousel-image-5-25866adb42da278455bc0d514c21de43.png";